import { IDanhMucToaXeResponseBase } from '@/core/interfaces/ApiResponses';

const useDanhMucToaXe = () => {
  const isValidLabel = (item: IDanhMucToaXeResponseBase) => {
    if (item.is_valid === 0) return 'Chờ phê duyệt';

    return 'Hợp lệ';
  };

  const isValid = (item: IDanhMucToaXeResponseBase) => item.is_valid !== 0;

  const isTextDangerColumn = ({ row }: { row: IDanhMucToaXeResponseBase }) =>
    row.is_valid === 0 ? 'text-danger' : '';

  return {
    isTextDangerColumn,
    isValid,
    isValidLabel,
  };
};

export default useDanhMucToaXe;
